import { UsagePermissionsInfo } from '../../components/usagePermissions/types'
import {
  ADD_USAGE_PERMISSIONS_SUCCESS,
  BaseActionType,
  DELETE_USAGE_PERMISSIONS_SUCCESS,
  LOAD_MORE_USAGE_PERMISSIONS_SUCCESS,
  LOAD_USAGE_PERMISSIONS_SUCCESS,
  UPDATE_USAGE_PERMISSIONS_SUCCESS,
} from '../actions/actionTypes'

import { UsagePermissionsState } from './initialState'

const initialStateUsagePermissions: UsagePermissionsState = {
  usagePermissions: [],
  continuationToken: '',
}

export function usagePermissionsReducer(
  state = initialStateUsagePermissions,
  action: BaseActionType,
): UsagePermissionsState {
  switch (action.type) {
    case ADD_USAGE_PERMISSIONS_SUCCESS: {
      return {
        ...state,
        usagePermissions: [
          action.payload as UsagePermissionsInfo,
          ...state.usagePermissions,
        ],
      }
    }
    case UPDATE_USAGE_PERMISSIONS_SUCCESS: {
      const usagePermissions = state.usagePermissions.map(
        (usagePermission: UsagePermissionsInfo) =>
          usagePermission.id !== (action.payload as UsagePermissionsInfo).id
            ? usagePermission
            : (action.payload as UsagePermissionsInfo),
      )
      return { ...state, usagePermissions }
    }
    case LOAD_USAGE_PERMISSIONS_SUCCESS:
      return action.payload as UsagePermissionsState
    case LOAD_MORE_USAGE_PERMISSIONS_SUCCESS:
      return {
        continuationToken: (action.payload as UsagePermissionsState)
          .continuationToken,
        usagePermissions: [
          ...state.usagePermissions,
          ...(action.payload as UsagePermissionsState).usagePermissions,
        ],
      }
    case DELETE_USAGE_PERMISSIONS_SUCCESS: {
      const usagePermissions = state.usagePermissions.filter(
        (usagePermissions: UsagePermissionsInfo) =>
          usagePermissions.usage !==
          (action.payload as UsagePermissionsInfo).usage,
      )
      return { ...state, usagePermissions }
    }
    default:
      return state
  }
}
